export default __webpack_public_path__ + "static/plx2021-642143b999bc2368b0be151e47ba981d.jpg";